angular.module('FlexyBeautyApp.services')
    .factory('ErrorCode', [function () {

        let errorCode = {
            SESSION_TOKEN_INVALID :     {code: '40103'},
            CHANNEL_INVALID:            {code: '40104'},
            CHANNEL_EXPIRED:            {code: '40105'},
            BOOKING_CONFLICT :          {code: '40930'},
            SALE_CONFLICT :             {code: '40940'},
            COMPANY_EMAIL_CONFLICT:     {code: '40950'}
        };

        return errorCode;
    }]);



// WEBPACK FOOTER //
// ./js/services/tools/ErrorCode.js